export const keyManageConstants = {
  GET_ALL_KEYS_REQUEST: "GET_ALL_KEYS_REQUEST",
  GET_ALL_KEYS_SUCCESS: "GET_ALL_KEYS_SUCCESS",
  GET_ALL_KEYS_FAILURE: "GET_ALL_KEYS_FAILURE",

  GET_KEY_TOP_INFO_REQUEST: "GET_KEY_TOP_INFO_REQUEST",
  GET_KEY_TOP_INFO_SUCCESS: "GET_KEY_TOP_INFO_SUCCESS",
  GET_KEY_TOP_INFO_FAILURE: "GET_KEY_TOP_INFO_FAILURE",

  CREATE_KEY_REQUEST: "CREATE_KEY_REQUEST",
  CREATE_KEY_SUCCESS: "CREATE_KEY_SUCCESS",
  CREATE_KEY_FAILURE: "CREATE_KEY_FAILURE",

  GET_ALL_OPEN_API_REQUEST: "GET_ALL_OPEN_API_REQUEST",
  GET_ALL_OPEN_API_SUCCESS: "GET_ALL_OPEN_API_SUCCESS",
  GET_ALL_OPEN_API_FAILURE: "GET_ALL_OPEN_API_FAILURE",

  GET_USER_OPEN_API_REQUEST: "GET_USER_OPEN_API_REQUEST",
  GET_USER_OPEN_API_SUCCESS: "GET_USER_OPEN_API_SUCCESS",
  GET_USER_OPEN_API_FAILURE: "GET_USER_OPEN_API_FAILURE",

  GET_KEY_DETAILS_REQUEST: "GET_KEY_DETAILS_REQUEST",
  GET_KEY_DETAILS_SUCCESS: "GET_KEY_DETAILS_SUCCESS",
  GET_KEY_DETAILS_FAILURE: "GET_KEY_DETAILS_FAILURE",

  ASSIGN_API_REQUEST: "ASSIGN_API_REQUEST",
  ASSIGN_API_SUCCESS: "ASSIGN_API_SUCCESS",
  ASSIGN_API_FAILURE: "ASSIGN_API_FAILURE",

  APPLY_API_KEY_FILTER_REQUEST: "APPLY_API_KEY_FILTER_REQUEST",
  APPLY_API_KEY_FILTER_SUCCESS: "APPLY_API_KEY_FILTER_SUCCESS",
  APPLY_API_KEY_FILTER_FAILURE: "APPLY_API_KEY_FILTER_FAILURE",

  GET_API_KEY_FILTERS_REQUEST: "GET_API_KEY_FILTERS_REQUEST",
  GET_API_KEY_FILTERS_SUCCESS: "GET_API_KEY_FILTERS_SUCCESS",
  GET_API_KEY_FILTERS_FAILURE: "GET_API_KEY_FILTERS_FAILURE",

  ACTIVATE_API_KEY_REQUEST: "ACTIVATE_API_KEY_REQUEST",
  ACTIVATE_API_KEY_SUCCESS: "ACTIVATE_API_KEY_SUCCESS",
  ACTIVATE_API_KEY_FAILURE: "ACTIVATE_API_KEY_FAILURE",

  DELETE_APIKEY_REQUEST: "DELETE_APIKEY_REQUEST",
  DELETE_APIKEY_SUCCESS: "DELETE_APIKEY_SUCCESS",
  DELETE_APIKEY_FAILURE: "DELETE_APIKEY_FAILURE",

  UPDATE_API_KEY_REQUEST: "UPDATE_API_KEY_REQUEST",
  UPDATE_API_KEY_SUCCESS: "UPDATE_API_KEY_SUCCESS",
  UPDATE_API_KEY_FAILURE: "UPDATE_API_KEY_FAILURE",
};
